export default __webpack_public_path__ + "static/media/TXUI_Foundation_Corner_8x1.256.986e4617.png";